import React from "react"

const DEFAULT_HEIGHT = 38

const StarbrixLogo = (props: React.ImgHTMLAttributes<HTMLImageElement> & { color?: "white" | "blue" }) => {
  const imgSrc = props.color === "white" ? "/starbrix-white.png" : "/starbrix.png"
  const height = props.height || DEFAULT_HEIGHT
  const style = { height, marginTop: -8, ...(props.style || {}) }
  return <img src={imgSrc} alt="Starbrix logo" {...props} style={style} />
}

export default StarbrixLogo
